import {ApiUrl} from "../../../auth/authMethods";
import React, {useState} from "react";
import PersonIcon from "@mui/icons-material/Person";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import PopupEdit from "../../../component/PopupEdit/PopupEdit";
import Select from "react-select";
import {DatePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {handleChangeData} from "../../../utils/handleChangeData";

const statusProtestoList = [
    {value: 'RECUSADO', label: 'Recusado'},
    {value: 'PROTESTADO', label: 'Protestado'},
    {value: 'EM_ANDAMENTO', label: 'Em andamento'},
    {value: 'NAO_EXECUTADO', label: 'Não executado'},
]

export default function PopupEditProtestData({item, setLoadData}) {

    const baseUrl = `${ApiUrl}/boletos/protesto`

    const [dataProtesto, setDataProtesto] = useState(item.dataProtesto)
    const [statusProtesto, setStatusProtesto] = useState(item.statusProtesto)


    const inputs = <>
        <DatePicker
            label="Data do protesto"
            sx={{
                width: '100%'
            }}
            value={dataProtesto ? dayjs(dataProtesto) : null}
            onChange={(e) => handleChangeData(e, setDataProtesto)}
        />

        <Select
            className="basic-single mb-4"
            classNamePrefix="select"
            id="form_select"
            required={true}
            defaultValue={statusProtestoList.filter(item => item.value === statusProtesto)}
            isDisabled={false}
            isLoading={false}
            isClearable={false}
            isRtl={false}
            isSearchable={true}
            options={statusProtestoList}
            onChange={(e) => setStatusProtesto(e.value)}
            placeholder={'Status *'}
        />
    </>

    const icon = <PersonIcon fontSize="large" id="icon-svg"/>
    const buttonText = <span>
        <DriveFileRenameOutlineIcon fontSize="medium"/> &nbsp;
        Editar Dados de Protesto
    </span>

    const itemToState = () => {
    }

    const returnData = () => {
        return {
            dataProtesto,
            statusProtesto
        }
    }

    return <PopupEdit
        baseUrl={baseUrl + `/${item.id}`} setLoadData={setLoadData}
        inputs={inputs} title={'Editar Dados de Protesto'} icon={icon}
        returnData={returnData} itemToState={itemToState}
        setErrorMessage={() => {
        }} setErrorColumn={() => {
    }}
        buttonText={buttonText} buttonClass='dropdown-item'
    />
}